import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
/** Styles Import */
import "./Styles/App.css";
import "./Styles/Common.css";
/** Services Import */
import Commons from "./Services/Common/Common";
import IndexedDb from "./Services/IndexedDb/IndexedDb";
import { LanguageProvider } from "./Components/LanguageSelector";
/** Components Import */
import Router from "./Routers/Router";
/** Store Import */
import store from "./Redux-Store/Store";

// Redux Persist 설정
// const persistor = persistStore(store);

function App() {
  Commons.Storages("set", "version", {
    version: "v1.1.1-alpha",
    updateDate: Commons.DateFormating(new Date()),
  });
  if (!Commons.Storages("get", "userInfo")) {
    Commons.Storages("set", "userInfo", { userId: "", userName: "" });
  }
  if (!Commons.Storages("get", "language")) {
    Commons.Storages("set", "language", { code: "KOR", name: "대한민국", flag: "https://flagcdn.com/kr.svg", lang: "ko" });
  }
  if (!Commons.Storages("get", "popup")) {
    Commons.Storages("set", "popup", { loginEduPopup: false });
  }

  IndexedDb.CreateIndexedDB();

  return (
    // <Provider store={store}>
    //   <PersistGate loading={null} persistor={persistor}>
    <LanguageProvider>
      <div className='App'>
        <Router />
      </div>
    </LanguageProvider>
    //   </PersistGate>
    // </Provider>
  );
}

export default App;
